import React, { useEffect, useState } from "react";
import "./SettlementSwitch.css";
import Modal from "../../../../components/modal/Modal";
import ConfigSetting from "./ConfigSetting";
import GetData from "../../../../api/GetData";
import DeleteData from "../../../../api/DeleteData"; // Assume handlePostApi can handle DELETE requests
import { ToastContainer, toast } from "react-toastify";
import AppData from "../../../../config/appData.json";
import Pagination from "../../../../components/Pagination";
import Table from "../../../../components/Table";

export default function SettlementSwitch() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [message, setMessage] = useState("");
  const [configData, setConfigData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [config, setConfig] = useState("");
  const postPerPage = 50;
  const lastPageNum = Math.ceil(configData?.length / postPerPage);
  const pageStart = (pageNumber - 1) * postPerPage + 1;

  console.log("message", message);

  const columns = React.useMemo(
    () => [
      {
        Header: "S/N",
        Cell: (row) => {
          return <div>{row.row.index + pageStart}</div>;
        },
      },
      {
        Header: "Switch Name",
        accessor: (row) => row.name || "N/A",
      },
      {
        Header: "Column Count",
        accessor: (row) => row.columnCount.toLocaleString(),
      },
      {
        Header: "Header Row No",
        accessor: (row) => row.headerRowNumber.toLocaleString(),
      },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="btn-area">
            <button className="btn edit-switch-btn" onClick={() => handleEditConfig(row.original)}>Edit</button>
            <button className="btn delete-switch-btn" onClick={() => onDelete(row.original)}>Delete</button>
          </div>
        ),
      },
    ],
    [pageNumber]
  );

  const handleCreateConfig = () => {
    setSelectedConfig(null);
    setIsModalOpen(true);
  };

  const handleEditConfig = (config) => {
    setSelectedConfig(config);
    setIsModalOpen(true);
  };

  const onDelete = (config) => {
    setIsDeleteModal(true);
    console.log(config);
    setConfig(config);
  };

  const handleDeleteConfig = async (configName) => {
    try {
      const endpoint = `${AppData.PAYMENT_URL}config/switch/settlements/${configName}`;
      const response = await DeleteData(endpoint);
      toast(response.data.message);
      fetchSettlementConfig();
    } catch (error) {
      console.error("Error deleting configuration", error);
      toast.error("Error deleting configuration");
    } finally {
      setIsDeleteModal(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedConfig(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModal(false);
  };

  const fetchSettlementConfig = async () => {
    try {
      const endpoint = AppData.PAYMENT_URL + `config/switch/settlement`;
      const response = await GetData(endpoint);
      console.log("response", response);
      setConfigData(response);
    } catch (error) {
      console.log("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (message?.trim().length > 0) {
      console.log("message in useEffect", message);
      toast(message);
      setMessage(""); // Clear the message after displaying the toast
    }
    fetchSettlementConfig();
  }, [message]);

  return (
    <div className="payment-settlement-switch">
      <div className="add-config">
        <button className="add-config-btn" onClick={handleCreateConfig}>
          Add Config
        </button>
      </div>
      <div className="table-responsive">
        {configData.data && configData.data.length > 0 ? (
          <Table
            columns={columns}
            data={configData.data}
            enableRowSelection={false}
            tableClass={"table table-borderless table-striped mb-0"}
          />
        ) : (
          <p>No record found</p>
        )}
        {lastPageNum > 1 && (
          <Pagination
            prevPage={pageNumber - 1}
            nextPage={pageNumber + 1}
            totalPages={lastPageNum}
            hasNextPage={pageNumber < lastPageNum}
            hasPrevPage={pageNumber > 1}
            setPageNum={setPageNumber}
          />
        )}
      </div>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          content={
            <ConfigSetting
              setMessage={setMessage}
              setIsModalOpen={setIsModalOpen}
              config={selectedConfig} // Pass the selected config to ConfigSetting
            />
          }
        />
      )}
      {isDeleteModal && (
        <Modal
          isOpen={isDeleteModal}
          onClose={closeDeleteModal}
          content={
            <ConfirmDeleteContent
              onClose={closeDeleteModal}
              onConfirm={() => handleDeleteConfig(config.name)}
              setIsDeleteModal={setIsDeleteModal}
              config={config}
            />
          }
        />
      )}
      <ToastContainer />
    </div>
  );
}

function ConfirmDeleteContent({ onClose, onConfirm, config }) {
  return (
    <div>
      <h5 className="modal-title">Confirm Delete</h5>
      <div className="modal-body">
        <p>Are you sure you want to delete {config.name}</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="btn btn-danger" onClick={onConfirm}>
          Delete
        </button>
      </div>
    </div>
  );
}
